import {isWithinInterval, startOfDay, endOfDay} from 'date-fns';
import type {Gsoa_ProductCatalog_ProductInHouse as ProductInHouse} from '~/openapi';

export function visiblePriceValidTo(productInHouse: ProductInHouse): boolean {
	return (
		(isGlobusBonusPrice(productInHouse) && isBonusProgramPriceValidDate(productInHouse))
		|| isBargain(productInHouse)
		|| isDiscountPercentage(productInHouse)
	);
}

export function getNormalPrice(productInHouse: ProductInHouse) {
	const {originalPrice, actualPrice} = productInHouse;
	return originalPrice && actualPrice && originalPrice > actualPrice ? originalPrice : 0;
}

export function getCurrentPrice(productInHouse: ProductInHouse) {
	const {actualPrice, originalPrice} = productInHouse;
	return actualPrice && actualPrice > 0 ? actualPrice : originalPrice ?? 0;
}

export function isBonusProgramPriceValidDate(productInHouse: ProductInHouse) {
	return productInHouse.bonusProgramPrice?.priceValidFrom
		&& productInHouse.bonusProgramPrice?.priceValidTo
		&& isWithinInterval(new Date(), {
			start: startOfDay(new Date(productInHouse.bonusProgramPrice.priceValidFrom)),
			end: endOfDay(new Date(productInHouse.bonusProgramPrice.priceValidTo)),
		});
}

export function getMainTriplePrice(productInHouse: ProductInHouse) {
	if (isGlobusBonusPrice(productInHouse) && isBonusProgramPriceValidDate(productInHouse)) {
		if (isBargain(productInHouse) || isDiscountPercentage(productInHouse)) {
			return getCurrentPrice(productInHouse);
		}
		return getNormalPrice(productInHouse) || getCurrentPrice(productInHouse);
	}
	return getCurrentPrice(productInHouse);
}

export function getDisplayedPrice(productInHouse: ProductInHouse) {
	return isGlobusBonusPrice(productInHouse) && isBonusProgramPriceValidDate(productInHouse)
		? (productInHouse.bonusProgramPrice?.actualPrice ?? 0)
		: getCurrentPrice(productInHouse);
}

export function isGlobusBonusPrice(productInHouse: ProductInHouse): boolean {
	return !!productInHouse.bonusProgramPrice;
}

export function isBargain(productInHouse: ProductInHouse): boolean {
	return productInHouse.priceTagId === '12';
}

export function isDiscountPercentage(productInHouse: ProductInHouse) {
	return !!productInHouse.discountPercentage;
}
